import { Card } from '@/components/ui/card';
import { Star, Quote } from 'lucide-react';

export const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Maria ',
      location: 'Zimbabwe',
      rating: 5,
      text: 'Our safari with Peregrine Tours was absolutely magical! The attention to detail, knowledgeable guides, and seamless planning made it a trip of a lifetime. We saw the Big Five and experienced authentic African culture.',
      trip: 'South Luangwa Safari'
    },
    {
      name: 'Ali Chiwartze',
      location: 'Namibia',
      rating: 5,
      text: 'From Victoria Falls to Chobe, every moment was perfectly orchestrated. The team went above and beyond to ensure our honeymoon was unforgettable. Highly recommend for anyone seeking adventure and luxury!',
      trip: 'Honeymoon Package'
    },
    {
      name: 'David Chen',
      location: 'Australia',
      rating: 5,
      text: 'Exceptional service throughout our corporate retreat. Peregrine Tours handled our group of 25 with professionalism and created team-building experiences we\'ll never forget. The Zambezi River activities were thrilling!',
      trip: 'Corporate Team Building'
    },
    {
      name: 'Emma Thompson',
      location: 'Canada',
      rating: 5,
      text: 'As a solo female traveler, I felt completely safe and well taken care of. The guides were incredibly knowledgeable, and the accommodations were stunning. The Maasai Mara was everything I dreamed of and more!',
      trip: 'Maasai Mara Adventure'
    },
    {
      name: 'Caroline Chiwaze',
      location: 'Botswana',
      rating: 5,
      text: 'The walking safaris in Kafue National Park were extraordinary. Our guide\'s expertise and passion for wildlife made every day an adventure. Peregrine Tours exceeded all our expectations!',
      trip: 'Kafue Walking Safari'
    },
    {
      name: 'Natalie Sithole',
      location: 'South Africa',
      rating: 5,
      text: 'We\'ve traveled extensively, but our Mana Pools experience stands out as one of the best. The combination of pristine wilderness, fantastic guides, and thoughtful sustainability practices impressed us deeply.',
      trip: 'Mana Pools Expedition'
    }
  ];

  return (
    <section className="section-padding bg-gradient-to-b from-background to-muted/30">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4">
            Testimonials
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-6 font-serif leading-tight">
            Hear From Our Travelers
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Real stories from real adventurers who experienced the magic of Africa with Peregrine Tours & Safaris.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="p-6 border-2 hover:border-primary/30 transition-all duration-300 hover:shadow-lg flex flex-col"
            >
              {/* Quote Icon */}
              <div className="mb-4">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Quote className="w-6 h-6 text-primary" />
                </div>
              </div>

              {/* Stars */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 text-primary fill-current"
                  />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-muted-foreground leading-relaxed mb-6 flex-1">
                "{testimonial.text}"
              </p>

              {/* Trip Badge */}
              <div className="mb-4">
                <span className="inline-block text-xs px-3 py-1 bg-accent/10 text-accent rounded-full font-medium">
                  {testimonial.trip}
                </span>
              </div>

              {/* Author Info */}
              <div className="pt-4 border-t border-border">
                <p className="font-semibold text-foreground">{testimonial.name}</p>
                <p className="text-sm text-muted-foreground">{testimonial.location}</p>
              </div>
            </Card>
          ))}
        </div>

        {/* Social Proof Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2 font-serif">500+</div>
            <div className="text-sm text-muted-foreground">Happy Travelers</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2 font-serif">4.9</div>
            <div className="text-sm text-muted-foreground">Average Rating</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2 font-serif">15+</div>
            <div className="text-sm text-muted-foreground">Destinations</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2 font-serif">4+</div>
            <div className="text-sm text-muted-foreground">Years Experience</div>
          </div>
        </div>
      </div>
    </section>
  );
};